export default __webpack_public_path__ + "static/media/ig.553d626a.svg";